(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
      class StickyAddToCart extends HTMLElement {
        connectedCallback() {
          const section = this.closest('[id^="ProductSection-"]');
          this.anchor = section?.querySelector('[id^="ProductSubmitButton-"]') || section;
          if (!this.anchor) return;
          this.checkState = this.checkState.bind(this);
          window.addEventListener('scroll', this.checkState, { passive: true });
          window.addEventListener('resize', this.checkState, { passive: true });
          this.checkState();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.checkState);
          window.removeEventListener('resize', this.checkState);
          cancelAnimationFrame(this.raf);
        }

        checkState() {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => {
            const shouldShow = window.innerWidth < 769 || this.anchor.getBoundingClientRect().bottom < 0;
            this.classList.toggle('active', shouldShow);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-combo-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-combo-bar')) {
    customElements.define(
      'sticky-combo-bar',
      class StickyComboBar extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('[id^="ProductSection-"]');
          this.combo = this.section?.querySelector('product-combo');
          if (!this.combo) {
            this.hidden = true;
            return;
          }
          this.anchor = this.combo.querySelector('[data-product-combo-price-wrapper]') || this.combo;
          this.priceWrapper = this.querySelector('[data-combo-sticky-price]');
          this.finalEl = this.querySelector('[data-combo-sticky-final]');
          this.originalEl = this.querySelector('[data-combo-sticky-original]');
          this.countEl = this.querySelector('[data-combo-sticky-count]');
          this.addBtn = this.querySelector('[data-combo-sticky-add]');

          this.checkState = this.checkState.bind(this);
          this.syncPrice = this.syncPrice.bind(this);
          window.addEventListener('scroll', this.checkState, { passive: true });
          window.addEventListener('resize', this.checkState, { passive: true });
          this.combo.addEventListener('combo:price-change', this.syncPrice);
          this.addBtn.addEventListener('click', () => this.addToCart());

          this.syncPrice();
          this.checkState();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.checkState);
          window.removeEventListener('resize', this.checkState);
          this.combo?.removeEventListener('combo:price-change', this.syncPrice);
          cancelAnimationFrame(this.raf);
        }

        syncPrice() {
          const source = this.combo.querySelector('[data-product-combo-price-wrapper]');
          if (!source) return;
          const onSale = source.classList.contains('on-sale');
          this.finalEl.innerHTML = source.querySelector('[data-product-combo-price-final]')?.innerHTML || '';
          this.originalEl.innerHTML = source.querySelector('[data-product-combo-price]')?.innerHTML || '';
          this.priceWrapper.classList.toggle('on-sale', onSale);
          const count = this.combo.querySelectorAll('.combo__item').length;
          this.countEl.textContent = this.dataset.countLabel?.replace('[count]', count) || '';
        }

        async addToCart() {
          if (typeof this.combo.addToCart !== 'function') return;
          this.addBtn.classList.add('is-loading');
          try {
            await this.combo.addToCart();
          } finally {
            this.addBtn.classList.remove('is-loading');
          }
        }

        checkState() {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => {
            const shouldShow = this.anchor.getBoundingClientRect().bottom < 0;
            this.classList.toggle('active', shouldShow);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
